import {useQuery} from "@tanstack/react-query";
import {apiGetOrganization} from "../../../data/api/organisation";

export const useGetOrganizationByUserName = (username) => {
    return useQuery({
        queryKey: ['organization', 'username',username],
        queryFn: () => apiGetOrganization(username),
    })
}